import { useSelector } from "react-redux";

const useHasPrivilege = (sectionName, privilegeKey) => {
  const { catalog = {}, allowed = [] } = useSelector(
    (state) => state.userPrivileges
  );
  // console.log(catalog, "car!");
  // console.log(allowed, "alooweed!");
  const section = catalog[sectionName];
  if (!section || !section.idMap) return false;

  const privilegeId = section.idMap[privilegeKey];
  if (!privilegeId) return false;

  return allowed.includes(privilegeId);
};

export default useHasPrivilege;
